import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation('common');

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-6 md:px-10 py-16">
        <div className="max-w-7xl mx-auto">
          {/* Top area */}
          <div className="mb-12">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-background-50">
              {t('footer.brand')}
            </h2>
          </div>

          {/* Three columns */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {/* Left column */}
            <div>
              <p className="text-sm text-background-50/70 leading-relaxed max-w-xs">
                {t('footer.description')}
              </p>
              <div className="flex items-center gap-4 mt-6">
                <button className="w-9 h-9 rounded-full border border-background-50/30 flex items-center justify-center text-background-50 hover:bg-background-50/10 transition-colors cursor-pointer" aria-label="Twitter">
                  <i className="ri-twitter-x-line text-sm" />
                </button>
                <button className="w-9 h-9 rounded-full border border-background-50/30 flex items-center justify-center text-background-50 hover:bg-background-50/10 transition-colors cursor-pointer" aria-label="Instagram">
                  <i className="ri-instagram-line text-sm" />
                </button>
                <button className="w-9 h-9 rounded-full border border-background-50/30 flex items-center justify-center text-background-50 hover:bg-background-50/10 transition-colors cursor-pointer" aria-label="TikTok">
                  <i className="ri-tiktok-line text-sm" />
                </button>
                <button className="w-9 h-9 rounded-full border border-background-50/30 flex items-center justify-center text-background-50 hover:bg-background-50/10 transition-colors cursor-pointer" aria-label="YouTube">
                  <i className="ri-youtube-line text-sm" />
                </button>
              </div>
            </div>

            {/* Middle column */}
            <div className="flex flex-col gap-6">
              <div>
                <p className="text-xs font-medium text-background-50/50 uppercase tracking-wider mb-1">
                  {t('footer.addressLabel')}
                </p>
                <p className="text-sm text-background-50/80">
                  {t('footer.addressValue')}
                </p>
              </div>
              <div>
                <p className="text-xs font-medium text-background-50/50 uppercase tracking-wider mb-1">
                  {t('footer.phoneLabel')}
                </p>
                <p className="text-sm text-background-50/80">
                  {t('footer.phoneValue')}
                </p>
              </div>
              <div>
                <p className="text-xs font-medium text-background-50/50 uppercase tracking-wider mb-1">
                  {t('footer.emailLabel')}
                </p>
                <p className="text-sm text-background-50/80">
                  {t('footer.emailValue')}
                </p>
              </div>
            </div>

            {/* Right column */}
            <div className="flex items-start justify-end">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20lifestyle%20flat%20lay%20with%20smartphone%20displaying%20shopping%20app%20surrounded%20by%20fashion%20accessories%20and%20coffee%20cup%20on%20light%20linen%20texture%2C%20soft%20natural%20morning%20light%2C%20warm%20beige%20and%20sand%20tones%2C%20cozy%20contemporary%20aesthetic%2C%20editorial%20product%20photography%2C%20aspirational%20consumer%20mood&width=400&height=500&seq=footer-v2-image&orientation=portrait"
                alt="CSSBuy Spreadsheet Products"
                className="w-32 h-40 object-cover rounded-lg"
              />
            </div>
          </div>

          {/* Disclaimer */}
          <p className="text-xs text-background-50/50 mt-10 leading-relaxed max-w-2xl">
            {t('footer.disclaimer')}
          </p>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-background-50/10">
        <div className="px-6 md:px-10 py-5 max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/50">
            {t('footer.copyright')}
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
              {t('footer.home')}
            </Link>
            <span className="text-xs text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
              {t('footer.policy')}
            </span>
            <span className="text-xs text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
              {t('footer.terms')}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}